import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import styled from '@emotion/styled';
import { Layout } from '../components/Layout';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  margin-top: 80px;
`

const Title = styled.h1`
  color: #4CAF50;
  margin-bottom: 2rem;
  text-align: center;
`

const ContactForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 600px;
  margin: 0 auto;
  padding: 2rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  label {
    font-weight: 500;
    color: #4a5568;
  }

  input, textarea {
    padding: 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    font-size: 1rem;
    transition: border-color 0.3s ease;

    &:focus {
      outline: none;
      border-color: #4CAF50;
      box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2);
    }
  }

  textarea {
    min-height: 150px;
    resize: vertical;
  }
`

const SubmitButton = styled.button`
  background: #4CAF50;
  color: white;
  padding: 1rem;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background: #45a049;
  }

  &:disabled {
    background: #a0aec0;
    cursor: not-allowed;
  }
`

const Message = styled.div`
  text-align: center;
  padding: 1rem;
  margin-top: 1rem;
  border-radius: 4px;
  
  ${props => props.type === 'success' && `
    background: #c6f6d5;
    color: #2f855a;
  `}
  
  ${props => props.type === 'error' && `
    background: #fed7d7;
    color: #c53030;
  `}
`

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically handle the form submission
    // For now, we'll just show a success message
    setStatus({ type: 'success', text: 'Thank you for your message! We will get back to you soon.' });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Layout>
      <Helmet>
        <title>Contact Us - Farmers Market Finder</title>
        <meta name="description" content="Get in touch with Farmers Market Finder. We'd love to hear from you and help you find local farmers markets in your area." />
      </Helmet>

      <Container>
        <Title>Contact Us</Title>
        <ContactForm onSubmit={handleSubmit}>
          <FormGroup>
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </FormGroup>

          <FormGroup>
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </FormGroup>

          <FormGroup>
            <label htmlFor="subject">Subject</label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
            />
          </FormGroup>

          <FormGroup>
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            />
          </FormGroup>

          <SubmitButton type="submit">Send Message</SubmitButton>
          
          {status && (
            <Message type={status.type}>
              {status.text}
            </Message>
          )}
        </ContactForm>
      </Container>
    </Layout>
  );
}

export default Contact;
